// The small £ GBP / ₹ INR switch beside an expense's amount (Karan 01/11/2026: expenses in
// rupees). Every expense form draws this one: Add expense, Add an expense (the pilot's
// column and panel) — never a mileage form (mileage is pounds and miles, v4.36.13). The default is the person's office (my-currency.js);
// anyone can switch it. Built with DOM nodes and fixed labels only.
import { CURRENCIES, cleanCurrency } from '../expense-currency.js';

const LABEL = { GBP: '£ GBP', INR: '₹ INR' };
const NAME = { GBP: 'Pounds', INR: 'Rupees' };

/**
 * compact: the small one that sits in a field's label line (the pilot's 420px column).
 * → { el, value(), set(cur, { silent }), touched(), disable(on) }
 *   onChange(cur) runs on a person's tap (and on set() unless silent).
 */
export function currencySeg({ value = 'GBP', onChange = () => {}, id = null, compact = false } = {}) {
  let cur = cleanCurrency(value);
  let touched = false;
  const el = document.createElement('div');
  el.className = `ax-seg cur-seg${compact ? ' cur-seg-sm' : ''}`;
  el.setAttribute('role', 'group');
  el.setAttribute('aria-label', 'Currency');
  if (id) el.id = id;
  const buttons = CURRENCIES.map((c) => {
    const b = document.createElement('button');
    b.type = 'button'; b.dataset.cur = c; b.textContent = LABEL[c]; b.title = NAME[c];
    el.appendChild(b);
    return b;
  });
  const paint = () => buttons.forEach((b) => { const on = b.dataset.cur === cur; b.classList.toggle('on', on); b.setAttribute('aria-pressed', String(on)); });
  el.addEventListener('click', (e) => {
    const b = e.target.closest('[data-cur]');
    if (!b || b.disabled) return;
    touched = true;
    if (b.dataset.cur === cur) return;
    cur = b.dataset.cur; paint(); onChange(cur);
  });
  paint();
  return {
    el,
    value: () => cur,
    touched: () => touched,
    /** Set it (the office default arriving, or the receipt read in rupees). */
    set(c, { silent = false } = {}) { const next = cleanCurrency(c); if (next === cur) return; cur = next; paint(); if (!silent) onChange(cur); },
    disable(on) { buttons.forEach((b) => { b.disabled = !!on; }); },
  };
}
